import React, { useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row, Spin, Table, Tag, message } from "antd";
import { useId24 } from "../../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../../config/app-config";
import { ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import { DatamanagementService } from "../services/datamanagement-service";
import { AssignStatus } from "./enums/AssignStatus.enum";
import { ExecuteStatus } from "./enums/ExecuteStatus.enum";
import { SimulateStatus } from "./enums/SimulateStatus.enum";
import { Role } from "../common";
import { UserAccess } from "../../../drivers/id24/models/user-access";
import { Consditions, IuserProfile } from "../models/models-datamanagement";
import { useHistory } from "react-router-dom";
import { TableDatamanagementSimulate } from "./TableDatamanagementSimulate";

const appConfig = loadAppConfig();

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface Props {
  baseUrl: string;
  accessRole: any;
}

interface TDetailSimulate {
  afterCap: number;
  beforeBal: number;
  beforeCap: number;
  decreasedCap: number;
  listName: string;
  listNameList: TListNameList[];
  listTeam: {};
  sumBal: number;
  teamId: string;
  teamName: string;
  totalCapability: number;
  sumAccountOld?: number;
  resultSumBalOld?: number;
  resultSumBalNew?: number;
}
interface TListNameList {
  amt: number;
  cnt: number;
  list_name: string;
  oa_name: string;
  team_name: string;
  tmp_user_id: string;
}

export const FooterDataManagement: React.FC = () => {
  const { tokenAccess, id24Axios } = useId24();
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);
  const apiBaseUrlCore = id24Axios(appConfig.apiBaseUrl);
  const { push } = useHistory();
  const [getDataGetUser, setDataGetUser] = useState<any>([]);
  const [getUserName, setUserName] = useState<any>([]);
  const [getResualData, setResualData] = useState<Consditions[]>([]);
  const [AssignUserNew, setAssignUserNew] = useState<string>("");
  const [CleardistNew, setCleardistNew] = useState<number>(0);
  const [modalStatusApply, setModalStatusApply] = useState(false);
  const [modalStatusAssign, setModalStatusAssign] = useState(false);
  const [getConditions, setGetConditions] = useState<string>("");
  const [userProfile, setUserprofile] = useState<IuserProfile>({
    id: 0,
    level: "",
    name: "",
    oaCode: "",
    parentId: "",
    team: "",
    token: "",
    type: "",
    capabilities: {},
  });

  const [showModelSimulateinprogress, setShowModelSimulateinprogress] = useState(false);
  const [openModalSimulate, setOpenModalSimulate] = useState(false);
  const [LoadingModalsimulate, setLoadingModalsimulate] = useState<boolean>(false);
  const [getUpdateDateSimulate, setUpdateDateSimulate] = useState<any>();
  const [openModelSimulateinprogress, setOpenModelSimulateinprogress] = useState(false);
  const [loadingTextTable, setLoadingTextTable] = useState<string>("");

  useEffect(() => {
    mapRoleAccess().then(async (resultmap) => {
      getUserProfile().then(async (resualProfile) => {
        const userAssign = () => {
          let AssignUserNew = `User:${resualProfile.id}:AssignUser`;
          setAssignUserNew(AssignUserNew);
          return AssignUserNew;
        };
        const userCleardist = () => {
          let AssignUserNew = resualProfile.id;
          setCleardistNew(AssignUserNew);
          return AssignUserNew;
        };
        userCleardist();
        await DatamanagementService(apiBaseUrlCore)
          .getDataManagementRuleBaseByname(userAssign())
          .then(async (resultDataRuleBase) => {
            if (resultDataRuleBase) {
              const resualUsername = await DatamanagementService(apiBaseUrlDebt).getUserInGroupDatamanagement();
              setUserName(resualUsername);
              setGetConditions(resultDataRuleBase);
              if (resultDataRuleBase === null) {
                return <></>;
              } else {
                const data: Consditions[] = await resultDataRuleBase.detail.map((x: Consditions, index: number) => {
                  console.log(x);
                  const mapData = {
                    key: index + 1,
                    seq: x.seq,
                    listname: x.listname,
                    days: x.days,
                    status: x.status,
                    description: x.description,
                    createDate: x.createDate,
                    createBy: x.createBy,
                    type: x.type,
                    fields: x.fields,
                    assignType: x.assignType,
                    distribution: x.distribution,
                    expression: x.expression,
                    updateBy: x.updateBy,
                    number_dtlLastPay: x.number_dtlLastPay,
                  };
                  return mapData;
                });
                setResualData(data);
              }
            }
          });
      });
    });
  }, []);

  const mapRoleAccess = () => {
    return new Promise<any>(async (resolve, reject) => {
      const result = tokenAccess?.userAccess.map((group: UserAccess) => group.groupName);
      resolve(result);
    });
  };
  const getUserProfile = async () => {
    return new Promise<IuserProfile>(async (resolve, reject) => {
      const resualProfile = await DatamanagementService(apiBaseUrlDebt).getUserDetail();
      resolve(resualProfile);
      setUserprofile(resualProfile);
    });
  };

  const apply_B = async () => {
    const executeStatus = await DatamanagementService(apiBaseUrlDebt).executeStatus(CleardistNew);
    if (executeStatus.status === ExecuteStatus.IN_PROGRESS) {
      setModalStatusApply(true);
      return;
    } else {
      Modal.confirm({
        title: "คุณแน่ใจแล้วใช่ไหม",
        icon: <ExclamationCircleOutlined />,
        content: "กดยืนยันเพื่อดำเนินการ Apply",
        okText: "ยืนยัน",
        cancelText: "ยกเลิก",
        onOk: async () => {
          F_ExcuteData();
        },
        onCancel: () => {},
      });
    }
  };
  const F_ExcuteData = async () => {
    message.warning("กำลังดำเนินการ Apply งาน");
    let dataStringBasicUpdate: any = [];
    const newcondition: any = [];
    getResualData.map((x: Consditions, index: number) => {
      dataStringBasicUpdate.push({
        seq: index + 1,
        listname: x.listname,
        days: x.days,
        status: x.status,
        description: x.description,
        createDate: x.createDate,
        createBy: userProfile.id,
        type: x.type,
        fields: x.fields,
        assignType: x.assignType,
        distribution: x.distribution,
        expression: x.expression,
        updateBy: x.updateBy,
        number_dtlLastPay: x.number_dtlLastPay,
      });
    });
    newcondition.push({
      detail: dataStringBasicUpdate,
    });
    await DatamanagementService(apiBaseUrlCore).updateConditionByid(AssignUserNew, newcondition);
    await DatamanagementService(apiBaseUrlCore).setExecuteRuleBase(CleardistNew);
  };
  const assign_B = async () => {
    const executeStatus = await DatamanagementService(apiBaseUrlDebt).executeStatus(userProfile.id);
    if (executeStatus.status === ExecuteStatus.IN_PROGRESS) {
      setModalStatusApply(true);
      return;
    } else {
      const resultSimulate = await DatamanagementService(apiBaseUrlDebt).simulateStatus(userProfile);
      if (resultSimulate.status === SimulateStatus.IN_PROGRESS) {
        setShowModelSimulateinprogress(true);
      } else {
        setShowModelSimulateinprogress(false);
        setOpenModalSimulate(true);
        setLoadingModalsimulate(true);
        const resultSimulateAssign = await DatamanagementService(apiBaseUrlCore).simulateAssign(userProfile.id);
        setUpdateDateSimulate(resultSimulateAssign?.updateDate);
        if (resultSimulateAssign.detail?.userData !== undefined) {
          let dataToarray = [];
          for (let x in resultSimulateAssign.detail?.userData) {
            dataToarray.push({
              userid: x,
              data: resultSimulateAssign.detail?.userData[x],
            });
          }
          setDataGetUser(dataToarray);
        }
        setLoadingModalsimulate(false);
      }
    }
  };
  const buttonSimulate = async () => {
    message.warning("กำลังดำเนินการ Simulate งาน");
    setOpenModelSimulateinprogress(false);
    setOpenModalSimulate(false);
    await DatamanagementService(apiBaseUrlCore).setSimulateRuleBase(CleardistNew);
  };
  const buttonAssign = async () => {
    const assignStatus = await DatamanagementService(apiBaseUrlDebt).assignStatus(CleardistNew);
    if (assignStatus.status === AssignStatus.IN_PROGRESS) {
      message.warning("อยู่ระหว่างการดำเนินการ Assign งาน");
      setOpenModalSimulate(false);
      setModalStatusAssign(true);
      return;
    } else {
      setOpenModelSimulateinprogress(false);
      setOpenModalSimulate(false);
      message.warning("เริ่มทำการ Assign งาน");
      setLoadingTextTable("กำลังดำเนินการ Assign งาน");
      setLoadingModalsimulate(false);
      await DatamanagementService(apiBaseUrlCore).assignConditions(CleardistNew);
    }
  };

  const dateStamp = (stamp: any) => {
    const date = new Date(stamp);
    const timestamp = date.toLocaleString("th-TH");
    return timestamp;
  };

  return (
    <div>
      <Row
        gutter={[8, 8]}
        style={{
          justifyContent: "end",
          display: "flex",
          alignItems: "center",
          marginTop: 30,
          width: "100%",
        }}
      >
        <Col>
          <Button type="primary" onClick={apply_B}>{`Apply`}</Button>
        </Col>
        <Col>
          <Button block onClick={assign_B}>{`Simulate Manual`}</Button>
        </Col>
      </Row>

      <Modal
        open={openModalSimulate}
        onCancel={() => setOpenModalSimulate(false)}
        width={"80%"}
        title={
          <>
            <Row style={{ textAlign: "left" }}>Simulate ({dateStamp(getUpdateDateSimulate)})</Row>
          </>
        }
        footer={
          <>
            <Button type="primary" danger onClick={buttonSimulate}>
              Simulate
            </Button>
            <Button type="primary" onClick={buttonAssign}>
              Assign
            </Button>
          </>
        }
      >
        <Spin indicator={antIcon} tip={"Loading...."} spinning={LoadingModalsimulate}>
          <TableDatamanagementSimulate UserId={userProfile} dataCondition={getResualData} dataUser={getDataGetUser} dataUserName={getUserName} />
        </Spin>
      </Modal>
      <Modal
        title={
          <>
            <ExclamationCircleOutlined /> In progress
          </>
        }
        open={showModelSimulateinprogress}
        onCancel={() => {
          setShowModelSimulateinprogress(false);
        }}
        cancelText="cancel"
        footer={
          <>
            <Button
              type="primary"
              danger
              onClick={() => {
                setOpenModelSimulateinprogress(false);
              }}
            >
              Close
            </Button>
          </>
        }
      >
        อยู่ในระหว่างการ Simulate
      </Modal>
      {/* <<<----------- Modal apply in progress  */}
      <Modal
        title={
          <>
            <ExclamationCircleOutlined /> In progress
          </>
        }
        open={modalStatusApply}
        onCancel={() => {
          setModalStatusApply(false);
        }}
        cancelText="cancel"
        footer={
          <>
            <Button
              type="primary"
              danger
              onClick={() => {
                setModalStatusApply(false);
              }}
            >
              Close
            </Button>
          </>
        }
      >
        อยู่ในระหว่างการประมวลผลข้อมูล
      </Modal>
      {/* <<<----------- Modal assign in progress  */}
      <Modal
        title={
          <>
            <ExclamationCircleOutlined /> In progress
          </>
        }
        open={modalStatusAssign}
        onCancel={() => {
          setModalStatusAssign(false);
        }}
        cancelText="cancel"
        footer={
          <>
            <Button
              type="primary"
              danger
              onClick={() => {
                setModalStatusAssign(false);
              }}
            >
              Close
            </Button>
          </>
        }
      >
        อยู่ในระหว่างการ Assign งาน
      </Modal>
      <Modal
        title={
          <>
            <ExclamationCircleOutlined /> In progress
          </>
        }
        open={openModelSimulateinprogress}
        onCancel={() => {
          setOpenModelSimulateinprogress(false);
        }}
        cancelText="cancel"
        footer={
          <>
            <Button
              type="primary"
              danger
              onClick={() => {
                setOpenModelSimulateinprogress(false);
              }}
            >
              Close
            </Button>
          </>
        }
      >
        อยู่ในระหว่างการ Simulate
      </Modal>
    </div>
  );
};
